import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { galeriaService, URL_FOTOS } from "../../services/api";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";
import "./Galeria.css";

function Galeria() {
  const [filtroActivo, setFiltroActivo] = useState("todos");
  const [fotoAbierta, setFotoAbierta] = useState(null);
  const [fotos, setFotos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [galeriaAbierta, setGaleriaAbierta] = useState(false);

  const _filtros = [
    { id: "todos", label: "Todos" },
    { id: "unas", label: "Uñas" },
    { id: "pestanas", label: "Pestañas" },
  ];

  useEffect(() => {
    cargarFotos();
  }, []);

  const cargarFotos = async () => {
    setCargando(true);
    try {
      const respuesta = await galeriaService.obtenerTodas();
      setFotos(respuesta.data);
    } catch (error) {
      console.error("Error al cargar fotos", error);
    } finally {
      setCargando(false);
    }
  };

  const _fotosFiltradas = filtroActivo === "todos"
    ? fotos
    : fotos.filter((foto) => foto.categoria === filtroActivo);

  const _construirFilaReel = (offset) => {
    if (fotos.length === 0) return [];
    const base = Array.from({ length: 6 }, (_, i) => fotos[(i + offset) % fotos.length]);
    return [...base, ...base];
  };

  const _filaReelA = _construirFilaReel(0);
  const _filaReelB = _construirFilaReel(3);
  const _placeholdersReel = Array.from({ length: 12 }, (_, i) => i);

  const _contenedorGrid = {
    oculto: {},
    visible: { transition: { staggerChildren: 0.05 } },
  };

  const _itemGrid = {
    oculto: { opacity: 0, y: 18, scale: 0.96 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { type: "spring", stiffness: 260, damping: 18 } },
  };

  return (
    <section className="galeria" id="galeria">
      <AnimarAlScroll>
      <div className="contenedor">
        <button
          className={"galeria-trigger " + (galeriaAbierta ? "abierto" : "")}
          onClick={() => setGaleriaAbierta(!galeriaAbierta)}
          aria-expanded={galeriaAbierta}
          aria-label={galeriaAbierta ? "Ocultar galería" : "Ver galería"}
        >
          <div className="galeria-reel">
            {fotos.length > 0 ? (
              <>
                <div className="galeria-reel-fila galeria-reel-fila-a" aria-hidden="true">
                  {_filaReelA.map((foto, i) => (
                    <img
                      key={`a-${i}-${foto.id}`}
                      src={`${URL_FOTOS}/${foto.nombreArchivo}`}
                      alt=""
                      className="galeria-reel-foto"
                      draggable="false"
                    />
                  ))}
                </div>
                <div className="galeria-reel-fila galeria-reel-fila-b" aria-hidden="true">
                  {_filaReelB.map((foto, i) => (
                    <img
                      key={`b-${i}-${foto.id}`}
                      src={`${URL_FOTOS}/${foto.nombreArchivo}`}
                      alt=""
                      className="galeria-reel-foto"
                      draggable="false"
                    />
                  ))}
                </div>
              </>
            ) : cargando ? (
              <>
                <div className="galeria-reel-fila galeria-reel-fila-a" aria-hidden="true">
                  {_placeholdersReel.map((i) => (
                    <div key={`sk-a-${i}`} className="skeleton galeria-reel-foto"></div>
                  ))}
                </div>
                <div className="galeria-reel-fila galeria-reel-fila-b" aria-hidden="true">
                  {_placeholdersReel.map((i) => (
                    <div key={`sk-b-${i}`} className="skeleton galeria-reel-foto"></div>
                  ))}
                </div>
              </>
            ) : (
              <div className="galeria-reel-vacio">
                <span className="stack-icono">✦</span>
                <p>Mirá nuestro trabajo</p>
              </div>
            )}

            <div className="galeria-reel-overlay">
              <span className="galeria-reel-pill">
                {galeriaAbierta ? "Ocultar" : "Ver galería"}
                <span className="galeria-chevron">⌄</span>
              </span>
            </div>
          </div>
        </button>

        <AnimatePresence initial={false}>
          {galeriaAbierta && (
            <motion.div
              className="galeria-desplegable"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
            >
              <div className="galeria-desplegable-inner">
                <div className="galeria-filtros">
                  {_filtros.map((filtro) => (
                    <button
                      key={filtro.id}
                      className={`filtro-btn ${filtroActivo === filtro.id ? "activo" : ""}`}
                      onClick={() => setFiltroActivo(filtro.id)}
                    >
                      {filtro.label}
                    </button>
                  ))}
                </div>

                {cargando ? (
                  <div className="galeria-grid" aria-hidden="true">
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                      <div key={i} className="skeleton galeria-item"></div>
                    ))}
                  </div>
                ) : _fotosFiltradas.length === 0 ? (
                  <p style={{ textAlign: "center", color: "var(--gris-texto)" }}>Próximamente...</p>
                ) : (
                  <motion.div
                    className="galeria-grid"
                    key={filtroActivo}
                    variants={_contenedorGrid}
                    initial="oculto"
                    animate="visible"
                  >
                    {_fotosFiltradas.map((foto) => (
                      <motion.div key={foto.id} className="galeria-item" variants={_itemGrid}>
                        <img
                          src={`${URL_FOTOS}/${foto.nombreArchivo}`}
                          alt="Trabajo Glowroom MVD"
                          className="galeria-foto"
                          onClick={() => setFotoAbierta(foto)}
                        />
                      </motion.div>
                    ))}
                  </motion.div>
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      </AnimarAlScroll>

      <AnimatePresence>
        {fotoAbierta && (
          <motion.div
            className="lightbox-fondo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setFotoAbierta(null)}
          >
            <motion.div
              className="lightbox-contenido"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="lightbox-cerrar" onClick={() => setFotoAbierta(null)}>
                ✕
              </button>
              <img
                src={`${URL_FOTOS}/${fotoAbierta.nombreArchivo}`}
                alt="Trabajo Glowroom MVD"
                className="lightbox-foto"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}

export default Galeria;